import React, { useState } from 'react';
import nextArrow from '@/assets/arrowNext.png';
import video from '@/assets/vdo.png';
import { Link } from '@mui/material';
import Slider from 'react-slick';
import gallery from '@/assets/gall1.png';
import gallery2 from '@/assets/gall2.png';
import gallery3 from '@/assets/gall3.jpg';
const DescriptionTabs = () => {
  const settings = {
    dots: true,
    infinite: true,
    //lazyLoad: true,
    // speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 5000,
    //cssEase: 'linear',
  };
  return (
    <div className="descrt-component">
      <div className="row">
        <div className="col-12 col-md-4 col-xl-3">
          <div className="invst-info-form">
            <p className="f-20 text-black mb-3">ADVAC AS</p>
            <div className="advc-links">
              <Link to="" className="f-13">
                Why invest?
              </Link>
              <Link to="" className="f-13">
                Problem to be solved
              </Link>
              <Link to="" className="f-13">
                Our solution
              </Link>
              <Link to="" className="f-13">
                Team
              </Link>
              <Link to="" className="f-13">
                Milestones
              </Link>
              <Link to="" className="f-13">
                Strategy and objectives
              </Link>
              <Link to="" className="f-13">
                Market and trends
              </Link>
              <Link to="" className="f-13">
                Competitors
              </Link>
              <Link to="" className="f-13">
                Business-critical agreements
              </Link>
              <Link to="" className="f-13">
                Economy
              </Link>
              <Link to="" className="f-13">
                Financing
              </Link>
              <Link to="" className="f-13">
                Appreciation
              </Link>
              <Link to="" className="f-13">
                Emissions technical conditions
              </Link>
              <Link to="" className="f-13">
                Exit strategy
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-8 col-xl-9">
          <div className="invest-right-box">
            <div className="row">
              <div className="col-12 col-md-6">
                <p className="f-13">
                  Advac AS has developed and sells patented vacuum cleaner nozzles, which due to
                  their long and low design can be cleaned in places that you would otherwise not
                  reach.
                </p>
                <p className="f-13">
                  We have so far <strong>sold 10,000 units</strong> and now we continue the
                  international expansion with wholesalers in several countries!
                </p>
                <h4 className="f-20 text-black mt-4">Why invest?</h4>
                <ul className="invest-list f-13">
                  <li>10,000 units sold</li>
                  <li>Production capacity of 40,000 units per month</li>
                  <li>Tools for production already paid off</li>
                  <li>Patented</li>
                  <li>Extended PCT application for patent in 207 countries</li>
                  <li>Distribution in 14 countries</li>
                  <li>Good margins and low costs combined with clearly defined markets</li>
                  <li>
                    Cost-effective and ensured efficient operation through wholesalers and agents
                  </li>
                  <li>A market of 480 million homes in our three focus areas</li>
                  <li>Aiming for 1% market share!</li>
                </ul>
              </div>
              <div className="col-12 col-md-6">
                <div className="video-frame">
                  <img src={video} alt="" className="w-100" />
                </div>
              </div>
            </div>

            <h4 className="f-20 text-black">Problem to be solved</h4>
            <p className="f-13">
              Most homes have areas that normal cleaning tools cannot reach, for example under
              refrigerators, stoves, bathtubs, low furniture, hot water tanks and behind the TV.
              These places are perfect collection points for dust and dirt, as it is difficult and
              cumbersome to clean them with ordinary vacuum cleaner nozzles. This can lead to
              several problems:
            </p>
            <ul className="invest-list f-13">
              <li>
                <span className="semi-bold">Poorer indoor climate:</span>  Accumulation of dust and
                dirt in these areas can worsen the air quality in the home, which can have negative
                health effects, especially for people with allergies or asthma.
              </li>
              <li>
                <span className="semi-bold">Increased health problems: </span>  Dust accumulations
                can contribute to respiratory problems and other health problems, especially in
                homes where children, the elderly or people with weakened immune systems live.
              </li>
              <li>
                <span className="semi-bold"> Increased fire risk: </span> Accumulation of dust and
                dirt near electrical appliances can increase the risk of fire.
              </li>
            </ul>
            <p className="f-13">
              Often these places remain dirty because it is inconvenient to move appliances and
              furniture to clean them. Here we see how a standard vacuum cleaner nozzle is too large
              to reach these tight spaces, while our specially designed nozzle easily reaches and
              effectively removes dust and dirt.
            </p>
            <h4 className="f-20 text-black pt-3">Our solution</h4>
            <p className="f-13">
              Advac AS has developed the vacuum cleaner nozzle Reach AV-60, an innovative product
              designed to reach areas that ordinary nozzles cannot. The Reach AV-60 is 60
              centimeters long and only 12 millimeters high, which makes it ideal for cleaning under
              low furniture and appliances. The underside of the nozzle has a suction surface of 22
              centimeters, and our patented design makes it possible to reach places where competing
              products cannot.
            </p>
            <p className="f-13">
              Efficiency The Reach AV-60 has several holes on the underside of the nozzle, which
              provides a more efficient suction compared to the competition which only has a small
              suction hole on the top. This function ensures that dust and dirt are removed more
              thoroughly and quickly. In addition, the Reach AV-60 is manufactured in a hard plastic
              type that prevents the nozzle from getting stuck under furniture, which makes cleaning
              easier and more trouble-free.
            </p>
            <h4 className="f-20 text-black pt-3">Gallery</h4>
            <Slider {...settings}>
              <div className="gallery-slide-img">
                <img src={gallery} className="user-io" alt="" />
              </div>
              <div className="gallery-slide-img">
                <img src={gallery2} className="user-io" alt="" />
              </div>
              <div className="gallery-slide-img">
                <img src={gallery3} className="user-io" alt="" />
              </div>
              <div className="gallery-slide-img">
                <img src={gallery} className="user-io" alt="" />
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionTabs;
